import IdishcardInfo from "./info/idishcard_info";
import UpdateIdColumn from "./update/update_id_column";
import UpdateForAllModal from "./update/UpdateForAllModal";

const Function = () => (
    <div className="d-flex gap-3">
        <UpdateForAllModal />
        <UpdateIdColumn />
        <IdishcardInfo />
    </div>
);
export default Function;